import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  canonical, 
  ogImage,
  ogType = 'website',
  structuredData 
}) => {
  // Use environment variable or window.location.origin for dynamic URL
  const siteUrl = (typeof window !== 'undefined' ? window.location.origin : null) 
    || process.env.REACT_APP_BACKEND_URL 
    || 'https://piercepremiercleaning.com';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const defaultImage = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_pierce-premier/artifacts/dk5ckiun_image.png';
  const imageUrl = ogImage || defaultImage;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Pierce Premier Cleaning Services" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
